/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

/*
<Head>
	<link rel="stylesheet" href="https://use.typekit.net/rpz1lcm.css"></link>
</Head>
 */

import { ThemeOptions } from '@mui/material/styles';

export const typography: ThemeOptions = {
	typography: {
		htmlFontSize: 16,
		fontFamily: ['effra-cc', 'sans-serif'].join(','),
		h1: {
			fontSize: 48,
			fontWeight: 700,
			lineHeight: 1,
		},
		h2: {
			fontSize: 40,
			fontWeight: 400,
		},
		h3: {
			fontSize: 27,
			fontWeight: 400,
		},
		h4: {
			fontSize: 23,
			fontWeight: 400,
		},
		h5: {
			fontSize: 20,
			fontWeight: 400,
		},
		h6: {
			fontSize: 18,
			fontWeight: 500,
		},
		subtitle1: {
			fontSize: 18,
			fontWeight: 500,
		},
		subtitle2: {
			fontSize: 18,
			fontWeight: 400,
		},
		body1: {
			fontSize: 16,
			fontWeight: 400,
		},
		body2: {
			fontSize: 16,
			fontWeight: 500,
		},
		button: {
			fontSize: 15,
			fontWeight: 400,
			textTransform: 'none',
		},
		caption: {
			fontSize: 12,
			fontWeight: 400,
		},
		strong: {
			fontWeight: 600,
		},
		overline: {
			fontSize: 12,
			textTransform: 'uppercase',
			fontWeight: 600,
			letterSpacing: 1,
		},
		body1AsH1: {
			fontSize: 16,
			fontWeight: 400,
		},
		body1AsH2: {
			fontSize: 16,
			fontWeight: 400,
		},
		body2AsH2: {
			fontSize: 16,
			fontWeight: 500,
		},
		h3AsH1: {
			fontSize: 27,
			fontWeight: 400,
		},
		h4AsH1: {
			fontSize: 23,
			fontWeight: 400,
		},
		h6AsH2: {
			fontSize: 18,
			fontWeight: 500,
		},
	},
};

declare module '@mui/material/Button' {
	interface ButtonPropsVariantOverrides {
		inline: true;
		containedOnDark: true;
		outlinedOnDark: true;
	}
}
